import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OpsInputComponent } from '../ops-input/ops-input.component';
import { Subscription } from 'rxjs';
import { LocalStorageService, SessionManagerService } from '@ops/shared-types';
import { User } from 'legacy/shared/shared-types/src/lib/models/user.model';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ops-login',
  standalone: true,
  imports: [CommonModule, OpsInputComponent, TranslateModule],
  templateUrl: './ops-login.component.html',
  styleUrl: './ops-login.component.scss',
})
export class OpsLoginComponent implements OnInit, OnDestroy {
  badLogin: boolean;
  username: string;
  password: string;

  subscriptions: Array<Subscription> = [];

  constructor(
    private sessionManager: SessionManagerService,
    private localStorage: LocalStorageService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    //TODO: move this to app-component to avoid showing login screen unnessessarily
    // also talk to design about having a "welcome back" message displayed
    // this.loadingService.startLoadingSpinner();
    this.sessionManager.attemptResumeSession();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  @HostListener('document:keydown', ['$event']) onKeyDown(e: any) {
    if (e.key === 'Enter') {
      setTimeout(() => {
        this.login();
      }, 200);
      return;
    }
  }

  onInputUsername(event: any) {
    this.username = event?.target?.value || event || '';
  }

  onInputPassword(event: any) {
    this.password = event?.target?.value || event || '';
  }

  createAccount() {
    // TODO
  }

  login() {
    this.badLogin = false;
    const sub = this.sessionManager
      .login(this.username, this.password)
      .subscribe({
        next: (user: User) => {
          this.localStorage.clearData();
          this.sessionManager.setCurrentUser(user);
          this.sessionManager.attemptResumeSession();
          this.badLogin = false;
        },
        error: (e) => {
          window.alert(this.translateService.instant('windowAlert.generic.error', { error: e.error.message }));
          this.badLogin = true;
        },
      });
    this.subscriptions.push(sub);
  }
}
